import { placementConfigs } from './ad_ops/adPlacementMappings'

export default defineAppConfig({
  nuxtIcon: {},
  /**
   * The ConfigCat environment this app runs against, and the key into
   * openfeature/cacheKey.ts. Empty means the tenant has no group key, so it
   * writes no group cookie and is never server rendered.
   */
  tenant: '',
  openfeature: {
    multiProvider: true,
    localProvider: false,
    queryProvider: true,
  },
  redesignedNtpPaths: [''],
  googleTagManagerId: '',
  omitDefaultCategoryParam: false,
  externalCategories: [{ label: '', href: '' }],
  urls: {
    home: '/',
    article: '/article',
    video: '/video',
  },
  adops: {
    placements: placementConfigs,
    outbrain: {
      installationKey: '',
    },
    taboola: {
      publisherName: '',
    },
  },
})
